import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        uibModalInstance: '=',
        departments: '<',
        roles: '<',
        levels: '<',
        planningGroup: '<',
        targetId: '<',
        employeeTarget: '<'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.uibModalInstance.dismiss()"></button>
            <h2>{{ 'courses.Edit target' | translate }}</h2>
        </div>
        <div class="modal-body">
            <form-wrapper form="vm.form">
                <form-row error="vm.form.errors.courseTargets">
                    <span ng-bind-html="vm.form.errors.courseTargets"></span>
                </form-row>
                <div class="form">
                    <form-row ng-if="!vm.employeeTarget" error="vm.form.errors.departmentId">
                        <label class="label">{{ 'courses.Department' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <ui-select ng-model="vm.department" theme="selectize" title="{{ 'user.Choose department' | translate }}">
                                <ui-select-match placeholder="{{ 'user.Select or search a department in the list...' | translate }}">{{$select.selected.name}}</ui-select-match>
                                <ui-select-choices repeat="department in vm.modifiedDepartments | filter: $select.search">
                                    <span ng-bind-html="department.name | highlight: $select.search" class="{{department.class}}"></span>
                                </ui-select-choices>
                            </ui-select>
                        </div>
                    </form-row>
                    <form-row ng-if="!vm.employeeTarget" error="vm.form.errors.roleId">
                        <label class="label">{{ 'courses.Role' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <ui-select ng-model="vm.role" theme="selectize" title="{{ 'user.Choose role' | translate }}">
                                <ui-select-match placeholder="{{ 'user.Select or search a role in the list...' | translate }}">{{$select.selected.name}}</ui-select-match>
                                <ui-select-choices repeat="role in vm.modifiedRoles | filter: $select.search">
                                    <span ng-bind-html="role.name | highlight: $select.search" class="{{role.class}}"></span>
                                </ui-select-choices>
                            </ui-select>
                        </div>
                    </form-row>
                    <form-row ng-if="!vm.employeeTarget" error="vm.form.errors.levelId">
                        <label class="label">{{ 'courses.Level' | translate }}</label>
                        <div class="items">
                            <form-row-error></form-row-error>
                            <ui-select ng-model="vm.level" theme="selectize" title="{{ 'user.Choose level' | translate }}">
                                <ui-select-match placeholder="{{ 'user.Select or search a level in the list...' | translate }}">{{$select.selected.name}}</ui-select-match>
                                <ui-select-choices repeat="level in vm.modifiedLevels | filter: $select.search">
                                    <span ng-bind-html="level.name | highlight: $select.search" class="{{level.class}}"></span>
                                </ui-select-choices>
                            </ui-select>
                        </div>
                    </form-row>
                    <div ng-if="vm.employeeTarget" class="row">
                        <div class="row">
                            <span class="label">{{ 'courses.Employee' | translate }}</span>
                            <div class="items">
                                <span class="text">{{ vm.employeeTarget.employee.displayName }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button class="btn main" type="button" ng-click="vm.save()">{{ 'general.Save' | translate }}</button>
                </li>
                <li>
                    <button class="btn discrete" type="button" ng-click="vm.uibModalInstance.dismiss()"
                    >{{ 'general.Cancel' | translate }}</button>
                </li>
            </ul>
        </div>
    `
})
export default class {
    constructor ($translate, $q, lodash, FormFactory, TokenService, CourseService, ModalService,
                 UserResource, CourseResource, COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM, COURSE_TARGET_NEED_TYPE_ENUM) {
        this.FormFactory = FormFactory;
        this.lodash = lodash;
        this.$translate = $translate;
        this.$q = $q;
        this.lodash = lodash;
        this.FormFactory = FormFactory;
        this.TokenService = TokenService;
        this.CourseService = CourseService;
        this.COURSE_TARGET_NEED_TYPE_ENUM = COURSE_TARGET_NEED_TYPE_ENUM;
        this.COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM = COURSE_TARGET_NEED_TYPE_EXCEPTION_ENUM;
        this.ModalService = ModalService;
        this.UserResource = UserResource;
        this.CourseResource = CourseResource;
    }

    $onInit () {
        this.modifiedDepartments = this.mapClassifier(this.departments, this.$translate.instant('course.All departments'));
        this.modifiedRoles = this.mapClassifier(this.roles, this.$translate.instant('course.All roles'));
        this.modifiedLevels = this.mapClassifier(this.levels, this.$translate.instant('course.All levels'));

        this.createForm();
        this.initTarget();
    }

    mapClassifier (classifier, defaultName) {
        classifier = classifier.map((val) => ({ name: val.value, id: val.id }));
        classifier.unshift({
            name: defaultName,
            id: undefined,
            class: 'separated'
        });
        return classifier;
    }

    initTarget () {
        this.department = { id: undefined, name: this.$translate.instant('course.All departments') };
        this.role = { id: undefined, name: this.$translate.instant('course.All roles') };
        this.level = { id: undefined, name: this.$translate.instant('course.All levels') };

        // find correct object from array to display on form
        const target = this.lodash.find(this.planningGroup.planningGroupTargetsWithValue, { id: this.targetId });
        this.department = { id: target.departmentId, name: target.departmentName ? target.departmentName : this.$translate.instant('course.All departments') };
        this.role = { id: target.roleId, name: target.roleName ? target.roleName : this.$translate.instant('course.All roles') };
        this.level = { id: target.levelId, name: target.levelName ? target.levelName : this.$translate.instant('course.All levels') };
    }

    createForm () {
        this.form = this.FormFactory.create(this.planningGroup, model => model.$update({ id: model.id }));
    }

    beforeSave () {
        this.form.model.targets = this.planningGroup.planningGroupTargetsWithValue;

        this.lodash.remove(this.form.model.targets, { id: this.targetId });
        this.form.model.targets.push({
            id: this.targetId,
            departmentId: this.department.id,
            roleId: this.role.id,
            levelId: this.level.id,
            employeeId: this.employeeDrl ? this.employeeDrl.employeeId : null
        });
    }

    save () {
        this.beforeSave();
        const message = this.$translate.instant('planningGroup.confirm_target_change_for_planning_group');
        this.ModalService.confirm(message)
            .then(() => this.doSave());
    }

    doSave () {
        this.form.save()
            .then(() => this.uibModalInstance.close())
            // in case of error remove the last added drl
            .catch(() => this.form.model.targets.splice(-1, 1));
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/planningGroup/target/edit-deprecated/index.js